/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DailyActivityMonitoringLogHeaderDto } from './dailyActivityMonitoringLogHeaderDto.schema';

export const SaveDailyActivityMonitoringLogHeader = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => DailyActivityMonitoringLogHeaderDto).optional()
});

export type SaveDailyActivityMonitoringLogHeader = zod.input<typeof SaveDailyActivityMonitoringLogHeader>;
export type SaveDailyActivityMonitoringLogHeaderOutput = zod.output<typeof SaveDailyActivityMonitoringLogHeader>;
